import * as React from 'react';

import {
  type DateTimeContextProps,
  useFormattedDate,
} from '@rtkwlf/fenrir-react';

type FormattedDateProps = {
  timestamp: Date | null;
  format?: DateTimeContextProps['format'];
};

const FormattedDate: React.FunctionComponent<FormattedDateProps> = ({
  timestamp,
  format,
}) => {
  const formattedDate = useFormattedDate(
    timestamp ?? new Date(),
    format ?? 'prettyDateTime',
  );

  if (timestamp) {
    return <div>{formattedDate}</div>;
  }
};

const useFormatNullableDate = (
  timestamp: Date | null | undefined,
  format: DateTimeContextProps['format'] = 'prettyDate',
  fallback = '-',
) => {
  const formattedDate = useFormattedDate(timestamp ?? new Date(), format);

  return timestamp ? formattedDate : fallback;
};

export { FormattedDate, useFormatNullableDate };

export type { FormattedDateProps };
